import React from "react";
import { Modal } from "react-responsive-modal";
import {
  TitleProduct,
  SubTitleProduct,
  MiddleContainer,
} from "../../components/modal/style/ErrorModalStyle";
import ButtonComponent from "../Button";

import { Flex } from "../../styles/GlobalStyle";
import Property from "../../model/property";

const ErrorModal = ({
  stateModal,
  openCloseModal,
  childText,
  btnErrorText,
  textTitle,
}) => {
  return (
    <Modal
      open={stateModal}
      onClose={() => openCloseModal(!stateModal)}
      showCloseIcon={false}
      center
    >
      <ModalContent
        onPress={() => openCloseModal(!stateModal)}
        textTitle={textTitle}
        children={childText}
        btnErrorText={btnErrorText}
      />
    </Modal>
  );
};

export default ErrorModal;

function ModalContent({ onPress, children, btnErrorText, textTitle }) {
  const preset = Property.getPreset();
  return (
    <MiddleContainer>
      <Flex flex={1} justifyContent={"center"}>
        <TitleProduct className={"modalTitle"}>{textTitle}</TitleProduct>
        <hr />
        <SubTitleProduct className={"modalSubtitle"}>
          {children}
        </SubTitleProduct>
        <SubTitleProduct className={"modalSubtitle"}></SubTitleProduct>
        <Flex
          container
          flex={1}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <ButtonComponent
            padding={"0.25em 0"}
            width={"80%"}
            label={btnErrorText}
            backgroundColor={
              preset.app_home_color_primary
                ? preset.app_home_color_primary
                : "black"
            }
            color={preset.text_color}
            borderRadius={"30px"}
            onClick={onPress}
            fontSize={preset.fontSize ? `${preset.fontSize}px` : '2em'}
          />
        </Flex>
      </Flex>
    </MiddleContainer>
  );
}
